import { isDate } from './isDate';
import { isNumeric } from './isNumeric';

export const compare = (
  a: number | string,
  b: number | string,
  isAsc: boolean
) => {
  if (isDate(a) && typeof a === 'string' && typeof b === 'string') {
    const dateA = new Date(
      a.split('/')[2] + '-' + a.split('/')[1] + '-' + a.split('/')[0]
    );
    const dateB = new Date(
      b.split('/')[2] + '-' + b.split('/')[1] + '-' + b.split('/')[0]
    );
    if (isAsc) {
      return dateA > dateB ? 1 : -1;
    }
    return dateA > dateB ? -1 : 1;
  }

  if (isNumeric(a)) {
    const valueA = Number(a);
    const valueB = Number(b);
    return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
  }

  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
};
